function DefaultImageHandler(image: string, defaultImagePath: string) {
  const result = image.startsWith('http') ? image : defaultImagePath + image
  return result ? result : null
}
export default DefaultImageHandler
